<template>
  <radio-group v-model="model.target_devices" inline>
    <radio
      :title="$t('CampaignForm_Segment_TargetTriggeredDevices_All_Title')"
      :description="$t('CampaignForm_Segment_TargetTriggeredDevices_All_Desc')"
      label="all"
      data-qa="triggered-target-everyone-option-radio"
      border
    />
    <radio
      :title="$t('CampaignForm_Segment_TargetTriggeredDevices_Triggered_Title')"
      :description="
        $t('CampaignForm_Segment_TargetTriggeredDevices_Triggered_Desc')
      "
      label="triggered"
      data-qa="devices-target-device-option-radio"
      border
    />
    <radio
      :title="
        $t('CampaignForm_Segment_TargetTriggeredDevices_ExcludeTriggered_Title')
      "
      :description="
        $t('CampaignForm_Segment_TargetTriggeredDevices_ExcludeTriggered_Desc')
      "
      label="not_triggered"
      data-qa="devices-exclude-triggering-device-option-radio"
      border
    />
  </radio-group>
</template>

<script>
import RadioGroup from '@/common/components/form/RadioGroup'
import Radio from '@/common/components/form/Radio'

export default {
  name: 'TargetTriggeredDevices',

  components: { Radio, RadioGroup },

  props: {
    model: {
      required: true
    }
  },

  mounted() {
    if (this.model.target_devices === null) {
      this.model.target_devices = 'triggered'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/segment/TargetTriggeredDevices.vue